import { ifAuthenticatedButNotOnCall, ifValidArCall } from "@/router";

export default [
  {
    path: "/accounts-receivable",
    name: "arDashboard",
    beforeEnter: ifAuthenticatedButNotOnCall,
    component: () =>
      import(
        /* webpackChunkName: "arDashboard" */
        "@/modules/accounts-receivable/views/dashboard/ARDashboard.vue"
      )
  },
  {
    path: "/accounts-receivable/facilities/:facilityId/tenant/:tenantId",
    name: "arTenant",
    beforeEnter: ifValidArCall,
    component: () =>
      import(
        /* webpackChunkName: "arTenant" */
        "@/modules/accounts-receivable/views/tenant/ARTenant.vue"
      )
  },
  {
    path: "/accounts-receivable/facilities/:facilityId/tenant/:tenantId/payment-plan",
    name: "paymentPlan",
    beforeEnter: ifValidArCall,
    component: () =>
      import(
        /* webpackChunkName: "paymentPlan" */
        "@/modules/accounts-receivable/views/payment-plan/PaymentPlan.vue"
      )
  },
  {
    path: "/accounts-receivable/facilities/:facilityId/tenant/:tenantId/promise-to-pay",
    name: "promiseToPay",
    beforeEnter: ifValidArCall,
    component: () =>
      import(
        /* webpackChunkName: "promiseToPay" */
        "@/modules/accounts-receivable/views/promise-to-pay/PromiseToPay.vue"
      )
  },
  {
    path: "/accounts-receivable/tenant-search",
    name: "arTenantSearch",
    beforeEnter: ifValidArCall,
    component: () =>
      import(
        /* webpackChunkName: "arTenantSearch" */
        "@/modules/accounts-receivable/components/ARTenantSearch.vue"
      )
  }
];
